/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;height:100%;position:relative}.no-results[_ngcontent-%COMP%]{display:flex;height:100%;width:100%;align-items:center;justify-content:center;position:absolute;left:0;top:0}"];
export { styles as styles };
